import { Checkbox } from '@/shared/ui/forms/inputs/checkbox'

import type { FC } from 'react'

import type { BlockHeaderCheckboxProps } from '../types'

/**
 * Block.Title.Checkbox - Checkbox placed on the left of the title
 *
 * Allows placing a checkbox that should not trigger the opening/closing of the accordion.
 * Size is automatically set to 'md' to match the block proportions.
 *
 * @example
 * ```tsx
 * <Block.Title>
 *   <Block.Title.Checkbox checked={false} onChange={() => {}} />
 *   Section title
 * </Block.Title>
 * ```
 */
export const BlockHeaderCheckbox: FC<BlockHeaderCheckboxProps> = props => {
  return <Checkbox size="md" {...props} />
}

BlockHeaderCheckbox.displayName = 'BlockHeaderCheckbox'
